import MerchantEducationLiveClassroom from '@/api/merchant-education-live-classroom'

/**
 * 教务系统 - 直播教室管理
 */

const state = { }

const mutations = { }

const actions = {
  async list ({ commit }, params) {
    const result = await MerchantEducationLiveClassroom.list(params)
    return result
  },
  async getById ({ commit }, id) {
    const result = await MerchantEducationLiveClassroom.getById(id)
    return result
  },
  async insert ({ commit }, data) {
    const result = await MerchantEducationLiveClassroom.insert(data)
    return result
  },
  async update ({ commit }, data) {
    const result = await MerchantEducationLiveClassroom.update(data)
    return result
  },
  async remove ({ commit }, id) {
    const result = await MerchantEducationLiveClassroom.remove(id)
    return result
  },
  async getLiveClassroomOptions ({ commit }, id) {
    const result = await MerchantEducationLiveClassroom.getLiveClassroomOptions(id)
    return result
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-education-live-classroom.js